export default __webpack_public_path__ + "static/media/img_1.dc33630c.webp";